import React from 'react';

interface UserIconProps {
  className?: string;
}

const UserIcon: React.FC<UserIconProps> = ({ className = '' }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="5" r="3" stroke="currentColor" strokeWidth="1" fill="none"/>
    <path d="M2 14c0-4 2.5-6 6-6s6 2 6 6" stroke="currentColor" strokeWidth="1" fill="none"/>
  </svg>
);

export default UserIcon;